import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import MyAppCard from './MyAppCard';
import CategoriesDropdown from './MobileCategoriesDropdown';
import EmptyFavoritesTab from './EmptyFavoritesTab';
import { MISC, HELPFUL } from '../lib/constants';
import ToolsSearch from './ToolsSearch';
import DefaultCategoriesFeatured from './DefaultCategoriesFeatured';
import DefaultCategoriesHelpful from './DefaultCategoriesHelpful';
import getContent from '../lib/dictionaryFetcher';
import Discover from './Discover';

class MobileCategories extends React.Component {
  renderApps(category) {
    const {
      tools,
      setApp,
      setTool,
      toggleFavorite,
      app,
      recommendations,
      categories,
      categoryIndexes,
      changeTab,
      favorites,
      featured
    } = this.props;

    const user = get(app, 'context.user', {}),
      categoryName = get(category, 'name', '');

    const sharedProps = {
      user,
      tools,
      setApp,
      setTool,
      toggleFavorite
    };

    if (categoryName === MISC.FAVORITES) {
      category.items = favorites;
    }

    if (
      categoryName === MISC.FAVORITES &&
      get(category, 'items', []).length === 0
    ) {
      return <EmptyFavoritesTab {...this.props} />;
    } else if (categoryName === MISC.DISCOVER) {
      return (
        <Discover
          {...sharedProps}
          category={category}
          categories={categories}
          categoryIndexes={categoryIndexes}
          changeTab={changeTab}
          favorites={favorites}
          featured={featured}
          recommendations={recommendations}
          app={app}
        />
      );
    }

    return get(category, 'items', []).map((item, index) => (
      <MyAppCard
        {...sharedProps}
        app={item}
        key={`category-item-${index + 1}`}
      />
    ));
  }

  render() {
    const {
      activeKey,
      categories,
      changeTab,
      tools,
      toggleFavorite,
      setTool,
      setApp,
      app,
      recordClick,
      tracking,
      featured,
      search,
      experimentation
    } = this.props;

    // get the index of the current category
    let index = parseInt(activeKey, 10 /* base 10 */);
    if (isNaN(index)) {
      index = 0;
      // TODO log error message here
      // index means the index of the category tabs
      // which is supposed to be a number but something happened
    }

    // pick the correct category
    let category = categories[index];

    const user = get(app, 'context.user', {}),
      categoryName = get(category, 'name', '');

    const title = getContent('merchanthub', `categories.${categoryName}`, '');
    const heading = getContent(
      'merchanthub',
      `categories.title.featured.${categoryName}`,
      title
    );
    const locale = get(app, 'context.locale.locale', '');

    const helpful = get(HELPFUL, categoryName, ''),
      otss = get(app, 'context.user.eligibility.otss', []),
      hasPartner = otss.includes(helpful),
      isElmo = get(experimentation, helpful, false),
      isHawk = get(app, 'type', '').toLowerCase() === 'business',
      shouldDisplay = helpful && isHawk && isElmo && hasPartner,
      items = get(category, 'items', []),
      newCategories = [MISC.SELLING, MISC.SHOPPING_CARTS],
      isNewCategories = newCategories.includes(categoryName);

    return (
      <div id="merchanthub-mobile-categories">
        <CategoriesDropdown
          activeKey={activeKey}
          categories={categories}
          changeTab={changeTab}
          locale={locale}
          featured={featured}
          experimentation={experimentation}
          tools={tools}
        />
        <ToolsSearch
          tools={tools}
          user={user}
          toggleFavorite={toggleFavorite}
          setTool={setTool}
          setApp={setApp}
          recordClick={recordClick}
          tracking={tracking}
          search={search}
        />
        <div id="tools-list" className={`tools-list-${categoryName}`}>
          <DefaultCategoriesFeatured
            featured={featured[categoryName]}
            category={categoryName}
            callback={setApp}
          />

          {isNewCategories && items.length > 0 ? (
            <h2 className="tools-category-heading">{heading || title}</h2>
          ) : null}
          {this.renderApps(category)}
          {shouldDisplay && (
            <DefaultCategoriesHelpful
              helpful={helpful}
              category={categoryName}
              callback={setApp}
            />
          )}
        </div>
      </div>
    );
  }
}

MobileCategories.propTypes = {
  app: PropTypes.object,
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  favorites: PropTypes.array,
  activeKey: PropTypes.string,
  tools: PropTypes.object,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  changeTab: PropTypes.func,
  recordClick: PropTypes.func,
  tracking: PropTypes.object,
  featured: PropTypes.object,
  search: PropTypes.object,
  experimentation: PropTypes.object,
  recommendations: PropTypes.array
};

export default MobileCategories;
